import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { NEEDS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Approach = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="approach" className="relative py-24 sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-5">
            <Eyebrow>The approach</Eyebrow>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0B2B26]">
              Healthcare built for <span className="italic text-[#0E4D44]">modern Indian</span> households.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="text-base md:text-lg text-[#33504A] leading-relaxed">
              Irregular schedules, work pressure, sedentary routines, inadequate sleep and changing diets are shaping how urban professionals and families feel. Welcon brings clinical care, preventive health and lifestyle management into a single framework — so improvement is structured and sustainable, not dependent on short-term diets, isolated consultations or fragmented services.
            </p>
          </Reveal>
        </div>

        <div data-testid="needs-addressed-container" className="mt-16 sm:mt-24 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7 border-t border-[#0E4D44]/15">
            {NEEDS.map((n, i) => (
              <button
                key={n.id}
                data-testid={`need-item-${n.id}`}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className="group w-full text-left border-b border-[#0E4D44]/15 py-6 sm:py-7 flex items-baseline gap-5"
              >
                <span className="font-mono text-xs text-[#4A6660] w-8 shrink-0">0{i + 1}</span>
                <span className="flex-1">
                  <span className={`block font-display text-2xl sm:text-4xl tracking-tight transition-[color,transform] duration-500 ${active === i ? "text-[#0E4D44] translate-x-2" : "text-[#0B2B26]/55"}`}>{n.need}</span>
                  <span className="lg:hidden block mt-2 text-sm text-[#33504A]">{n.answer}</span>
                </span>
                <ArrowRight className={`h-5 w-5 shrink-0 transition-[opacity,transform] duration-500 text-[#D96B43] ${active === i ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-3"}`} />
              </button>
            ))}
          </div>
          <div className="hidden lg:block lg:col-span-5 sticky top-32">
            <div className="relative rounded-[28px] overflow-hidden aspect-[4/5]">
              <img src="/images/lifestyle.jpg" alt="Lifestyle-first wellness" className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B2B26]/90 via-[#0B2B26]/20 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#E9A184]">How Welcon responds</p>
                <motion.p key={active} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
                  data-testid="need-answer-text" className="mt-3 font-display text-3xl leading-tight text-[#F6F4EE]">
                  {NEEDS[active].answer}
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
